export default __webpack_public_path__ + "static/media/ECD.d94af758.png";